import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { SwatchService } from "../../../services/swatch.service";

@Component({
  selector: "swatchDetails",
  templateUrl: "./swatchDetails.html",
})
export class AddEditSwatch {
  row: any;
  data: any;
  colorList: any = [];
  swatchdata: any = { ref_no: "" };
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0, narration: "" };
  mode: string;
  saveEvent: any;
  sampleList: any;
  dclist: any;
  list: any;
  shirtList: any;
  rateList: any = [];
  isLoading: boolean = false;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let swatchdata = Object.assign({}, val["data"]);
    this.swatchdata = swatchdata;

    if (this.mode == "Edit" || this.mode == "View") {
      //this.saveEvent = val['data'].tabevent;
      this.loadeditswatchlist();
      this.onEnterdesign(this.swatchdata.design_no);
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("colorAuto") colorAuto;
  @ViewChild("brandAuto") brandAuto;
  @ViewChild("styleAuto") styleAuto;
  @ViewChild("shirtAuto") shirtAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  shirtCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private swatchservice: SwatchService
  ) {
    this.row = {
      color: "",
      shade: "",
    };
    this.data = {
      swatchList: [],
    };
    let row = Object.assign({}, this.row);
    this.data.swatchList.push(row);
  }
  ngOnInit() {
    if (this.mode == "Add") {
      this.swatchdata.ref_date = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
      this.getAuto();
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#date").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      color = this.data.swatchList[ind]["color"],
      shade = this.data.swatchList[ind]["shade"];

    let nxtRow = $("#row-" + ind).next("tr");
    // let data = this.isRowEmpty(ind);

    if (fld == "color" && nxtRow.length == 0) {
      for (let i = 0; i < this.data.swatchList.length; i++) {
        let len = this.data.swatchList.length;
        let color = this.data.swatchList[len - 1].color;
        let rowdetail = Object.assign({}, this.row);
        if (color != "") {
          this.data.swatchList.push(rowdetail);
        }
        nxtInd = this.data.swatchList.length - 1;
      }
    }

    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);
  }

  checkShade(shade, ind) {
    for (let i = 0; i < this.data.swatchList.length; i++) {
      let temp = this.data.swatchList[i];
      if (temp.shade == shade && ind !== i) {
        setTimeout(() => {
          this.data.swatchList[ind].shade = "";
        }, 300);

        swal("SHADE ALREADY EXISTS");
      }
    }
    if(this.mode == 'Edit'){
       
     return
    }
    let params = {
      shirtdno: this.swatchdata.shirt_no,
      shade: shade,
    };
    this.swatchservice.checkShade(params).then((res: any) => {
      if (res.shade) {
        this.data.swatchList[ind].shade = "";
        swal("THIS SHIRT NO & SHADE ALREADY EXISTS");
      }
    });
  }
  checkColor(color, ind) {
    for (let i = 0; i < this.data.swatchList.length; i++) {
      let temp = this.data.swatchList[i];
      if (temp.color == color && ind !== i) {
        setTimeout(() => {
          this.data.swatchList[ind].color = "";
        }, 300);

        swal("COLOR ALREADY EXISTS");
      }
    }

    if(this.mode == 'Edit'){
       
      return
     }
    let params = {
      shirtdno: this.swatchdata.shirt_no,
      color: this.data.swatchList[ind].color,
    };
    this.swatchservice.checkColor(params).then((res: any) => {
      if (res.color) {
        this.data.swatchList[ind].color = "";
        swal("THIS SHIRT NO & COLOR ALREADY EXISTS");
      }
    });
  }

  isRowEmpty(ind) {
    let data = this.data.swatchList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.swatchList.length > 1) {
          that.data.swatchList.splice(ind, 1);

          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) {}
    );
  }

  onclickdcno(dcno) {
    for (let i = 0; i < this.dclist.length; i++) {
      if (dcno == this.dclist[i].dc_no) {
        this.swatchdata.dc_id = this.dclist[i].dc_id;
      }
    }
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAuto() {
    this.swatchservice.getAuto({}).then((res: any) => {
      this.swatchdata.ref_no = res;
    });
  }

  oncheckemptyrow() {
    for (let i = 0; i < this.data.swatchList.length; i++) {
      let temp = this.data.swatchList[i];
      if (temp.color == "" || temp.shade == "") {
        swal("Make sure that the shade details are given!");
        return;
      }
    }
    if (this.data.swatchList[0]["color"] == "") {
      swal("Make sure that the shade details are given!");
    } else {
      let design = this.data.swatchList;
      let desList = [];
      for (let i = 0; i < design.length; i++) {
        if (design[i].color != "") {
          desList.push(design[i]);
        }
      }
      this.data.swatchList = desList;
      this.onSaveSwatch();
    }
  }

  onEnterdesign(design_no) {
    if (design_no == "") {
      this.sampleList = [];
      this.swatchdata.brand = "";
      this.swatchdata.style = "";
      this.swatchdata.shirt_no = "";
      this.swatchdata.sample_no = "";
      this.swatchdata.dc_no = "";
      this.swatchdata.mrpamount = "";
      this.data = {
        swatchList: [
          {
            color: "",
            shade: "",
          },
        ],
      };
    } else {
      let params = {
        design_no: design_no,
      };
      this.swatchservice.getsample(params).then((res: any) => {
        this.dclist = res.dcdata;
        if (res.data.length > 0) {
          this.sampleList = res.data;
        } else {
          this.swatchdata.vendor_name = "";
          this.swatchdata.rate = "";
          this.swatchdata.lcrate = "";
          this.colorList = res.coldata;
          this.rateList = res.ratedata;
          this.swatchdata.vendor_name = this.rateList[0].party_name;
          this.swatchdata.rate = this.rateList[0].rate;
          this.swatchdata.lcrate = this.rateList[0].lc_rate;

          //     this.data = {
          //     swatchList: [ {color:'',
          //     shade: '',}],
          // }
        }
      });
    }
  }

  onClickSample(sampleno) {
    if (sampleno == "") {
      this.swatchdata.brand = "";
      this.swatchdata.style = "";
      this.swatchdata.shirt_no = "";
      this.list = [];
      this.shirtList = [];
      this.colorList = [];

      // this.swatchdata.sample_no = '';
    } else {
      for (let i = 0; i < this.sampleList.length; i++) {
        if (sampleno == this.sampleList[i].sample_no) {
          this.swatchdata.samp_id = this.sampleList[i].samp_id;
        }
      }

      let params = {
        design_no: this.swatchdata.design_no,
        sample_id: this.swatchdata.samp_id,
      };
      this.swatchservice.getlist(params).then((res: any) => {
        this.list = res.data;
        this.shirtList = res.shirt;
        this.colorList = res.color;
        this.rateList = res.rate;
        this.swatchdata.vendor_name = this.rateList[0].party_name;
        this.swatchdata.rate = this.rateList[0].rate;
        this.swatchdata.lcrate = this.rateList[0].lc_rate;
      });
    }
  }
  /*onClickShirtdno(shirtdno){
          let params={
            design_no:this.swatchdata.design_no,
            sample_no :this.swatchdata.sample_no,
            shirtdno:shirtdno,

        }
        this.swatchservice
            .getcolor(params)
            .then((res: any) => {
                
                this.colorList = res.data;

            })
    }*/

  onSaveSwatch(): void {
    if (this.swatchdata.brand == "" || this.swatchdata.style == "") {
      swal("Make sure that all the details are given!");
    } else {
      let params: any = Object.assign({}, this.swatchdata);
      params["tabevent"] = undefined;
      params["data"] = JSON.stringify(this.data);
      params["dc_no"] = this.swatchdata.dc_no || "";
      params["dc_id"] = this.swatchdata.dc_id || "";
      params["date"] = this.datePipe.transform(params["date"], "yyyy-MM-dd");
      let that = this;
      that.isLoading = true;
      swal({
        title: "Are you sure to save this Swatch Details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.swatchservice
          .saveSwatch(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }

  loadeditswatchlist() {
    let params = {
      swatch_id: this.swatchdata.swatch_id,
    };
    this.swatchservice.getEditSwatchList(params).then((res: any) => {
      this.data.swatchList = res.data;
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/swatch/swatchDetails.ts